import React, { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import LoginPopup from "../container/LoginPopup";
import JPWRoutes from "../container/PrivateRoutes/jpw";
import LoggedOut from "../container/LoggedOut";
import AdminRoutes from "../container/PrivateRoutes/admin";
import {
  fieldForceAdminRoutes,
  fieldForceJPWRoutes,
} from "./fieldForceRoutes.js";
import { Navigate } from "react-router-dom";
import Tableau from "../container/Tableau";
import FocusSkuUpload from "../container/FocusSku/FocusSkuUpload";

export default function Routers() {
  const userData = JSON.parse(sessionStorage.getItem("user_details")) || {};
  const { userRole } = userData;
  const isAdmin = userRole === "SuperAdmin";
  const isPlanningLead= userRole==="PlanningLead";
  const isNHQ = userRole === "NHQ";
  const session = sessionStorage.getItem("session");

  return (
    <Suspense>
      <Routes>
      <Route element={<AdminRoutes />}>
          <Route
            exact
            path="/"
            element={
              <Navigate
                to={
                  isAdmin
                    ? "/employee/add"
                    : isPlanningLead
                      ? "/data/retailerMapping"
                      : isNHQ
                        ? "/resources/target-vs-achievement?session=nhq_session"
                        : "/resources/target-vs-achievement"
                }
              />
            }
          />
          {fieldForceAdminRoutes.map((Routes, i) => {
            return (
              <Route
                exact
                key={i}
                path={Routes.Path}
                element={
                  Routes.Component ? <Routes.Component /> : Routes.NavigateTo
                }
              />
            );
          })}
        <Route path="/focusSkuUpload" element={<FocusSkuUpload />} />
        </Route>
        <Route element={<JPWRoutes />}>
          <Route
            exact
            path="/"
            element={
              <Navigate
                to={isAdmin ? "/employee/add" : (session ? `/resources/target-vs-achievement?session=${encodeURIComponent(session)}` : "/resources/target-vs-achievement")}
              />
            }
          />
          {fieldForceJPWRoutes.map((Routes, i) => {
            return (
              <Route
                exact
                key={i}
                path={Routes.Path}
                element={
                  Routes.Component ? <Routes.Component /> : Routes.NavigateTo
                }
              />
            );
          })}
        </Route>
        <Route path="/tableau" element={<Tableau />} />
        <Route path="/login" element={<LoginPopup />} />
        <Route path="/logout-success" element={<LoggedOut />} exact />
        <Route path="*" element={<p>Page not found</p>} replace />
      </Routes>
    </Suspense>
  );
}
